module.exports = __webpack_public_path__ + "static/img/quiz-bad@2x.e5298bb3.png";